import { render, staticRenderFns } from "./RT.vue?vue&type=template&id=7126ccae"
import script from "./RT.vue?vue&type=script&lang=js"
export * from "./RT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports